<!--节能评估
日周月季年的负荷率
负荷率为合相有功功率除以额定功率（额定负荷只有变压器有而且一般是一样的）
-->
<template>
  <div class="energySaving">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='readDeviceTreeList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>节能评估</span>
          </div>
          <div class="btns">
            <el-button @click="downloadExcel" type="primary" class="last-el-button">导出</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <div class="input-small  myinput">
            <span></span>
            <el-select v-model="apptype" placeholder="请选择" @change="select_fn" style="margin-right:20px">
              <el-option v-for="item in apptypeGroups" :key="item.no" :label="item.name" :value="item.no"></el-option>
            </el-select>
          </div>
          <div class="input-small mr-20 myinput">
            <span></span>
            <el-select v-model="radioSelect" placeholder="请选择">
              <el-option v-for="item in timestype" :key="item.en" :label="item.ch" :value="item.en"></el-option>
            </el-select>
          </div>
          <div class="input-small">
            <span></span>
            <el-date-picker v-show="radioSelect=='day'" v-model="serchTime" type="date" placeholder="选择日期"
              :picker-options="pickerOptions"></el-date-picker>
            <el-date-picker v-show="radioSelect=='month' || radioSelect=='quarter'" v-model="serchTime" type="month"
              placeholder="选择月" :picker-options="pickerOptions"></el-date-picker>
            <el-date-picker v-show="radioSelect=='year'" v-model="serchTime" type="year" placeholder="选择年"
              :picker-options="pickerOptions"></el-date-picker>
          </div>
          <el-button type="primary" plain @click="search" class="search-btn">查询</el-button>
        </div>
        <div class="mychart" style="width:100%;height:450px">
          <vchart style="height: 100%;" ref='vchart'></vchart>
        </div>
        <el-table :data="nowShowDataList" border :max-height="heights" stripe style="width: 100%">
          <el-table-column label="序号" width="90" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="0" label="名称" width="250">
          </el-table-column>
          <el-table-column v-for='(item,index) in columns' :prop="(index+1).toString()" :label="item.name"
            :key="item.key" :width="item.width">
          </el-table-column>

        </el-table>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script type="text/javascript">

  import vchart from '@/components/module/chart/vchart.vue'
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  export default {
    components: {
      vchart,
      elUnitTree
    },
    props: [],
    data () {
      return {
        loading: false,
        heights: document.getElementById('app').clientHeight-700,
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          }
        },
        radioSelect: "day",
        timestype: [{
          ch: '日',
          en: 'day'
        },

        {
          ch: '月',
          en: 'month'
        },
        {
          ch: '季',
          en: 'quarter'
        },
        {
          ch: '年',
          en: 'year'
        }
        ],
        dataObject: {},
        nowApptypeGroup: {name: "用电日负荷",no: -1},//默认为第一个
        options: {
          color: ['#3AA1FF'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: '{c}',
          },
          legend: {
            data: []
          },
          grid: {
            top: 20,
            left: 15,
            right: 15,
            bottom: 10,
            containLabel: true
          },
          xAxis: [{
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: false
            }
          }],
          yAxis: {
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#CCCCCC'
              }
            },
            type: 'value'
          },
          series: []
        },
        apptype: -1,
        from2name: {},
        variableToDeviceNo: {},
        warnMessage: '',
        nowapptypeGroups: -2,

        serchTime: new Date(),
        fromName: {},
        nowVirtualDevice: [],
        nowVirtualDeviceList: []
      }
    },
    created () {
      //this.nowVirtualDeviceList
      // setTimeout(v => {
      // 	this.search()
      // },2500)
      //this.$store.deviceStore.commit('setSaveEnergyDeviceList',this.checkGroups);
      //this.checkGroups(data);
      // setTimeout(v => {
      // 	this.search()
      // },1500)
    },
    mounted () {
      debugPage=this
      //初始化图表
      this.options=this.$refs.vchart.getDefaultOptions()
      this.options.toolbox={
        show: true,
        showTitle: false, // 隐藏默认文字，否则两者位置会重叠
        top: '-5',
        right: "50",
        feature: {
          magicType: {
            type: ['line','bar','stack','tiled'],title: {
              line: '切换为折线图',
              bar: '切换为柱状图',
              stack: '切换为堆叠',
              tiled: '切换为平铺',
            }
          },

          saveAsImage: {
            show: true,
            title: '下载图片'
          },
          // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
        },

      },
        this.options.tooltip.formatter=(params,ticket,callback) => {
          var h=params[0].data[0]
          var label=params[0].data[0]+"</br>"
          params.forEach(item => {
            var values;
            if(isnull(item.data[1])) {
              if(this.nowApptypeGroup.no==-2) {
                values="配置缺失或无采集数据"
              } else {
                values="无采集数据"
              }
            } else {
              values=cutDigital(item.data[1])
              if(this.nowApptypeGroup.no==-2) {
                values+=" %"
              }
            }
            label+=this.nowApptypeGroup.name+" : "+values+"</br>"
          })
          return label;
        }

      this.$refs.vchart.setData(this.options,true)
    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      getOnedeviceNoToVariableTree () {
        return no => {

          return this.$store.variableStore.getters.getdeviceNoToVariableTree(no)
        }
      },
      readDeviceTreeList () {
        var str='36,237,361'
        var data=[deviceList(this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(str,this.nowUnit.id))]
        // console.log("数据",data);

        return data
        //  var data = this.$store.deviceStore.getters.getReadDeviceTree
        // return isempty(data) ? [] : [deviceList(data)]
      },


      // nowVirtualDeviceList () {
      //   return this.$store.deviceStore.state.saveEnergyDeviceList
      // },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowDateText () {
        return this.nowSelectDate.formatByDate('-')
      },
      deviceNoToVariableTree () {
        //debugger;
        if(isempty(this.nowVirtualDeviceList)) {
          return []
        }
        var treeRes={}
        this.nowVirtualDeviceList.forEach(item => {
          if(item.type=="virtualDevice") {
            treeRes[item.no]=this.$store.variableStore.getters.getVariableTree(item.no)
          }
        })
        return treeRes
      },
      getArchivesByDeviceNos () {
        return this.$store.archivesStore.getters.getArchivesByDeviceNos
      },
      nowVariableList () {
        //当前应该使用变量列表
        if(isempty(this.nowApptypeGroup)) {
          return []
        }
        var list=[]
        if(this.nowApptypeGroup.no==-1||this.nowApptypeGroup.no==-2) {
          var newVariableToDeviceNo={}
          //负荷率和负荷只要变量类型为31的变量
          var keys=Object.keys(this.deviceNoToVariableTree)
          keys.forEach(item => {
            //debugger
            this.deviceNoToVariableTree[item].forEach(treeItem => {
              for(var i2=0,len2=treeItem.next.length;i2<len2;i2++) {
                var item2=treeItem.next[i2]
                if(item2.typeNo==36||item2.typeNo==237||item2.typeNo==361) {
                  list.push(item2)
                  newVariableToDeviceNo[item2.fromName]=item
                }
              }
            })
          })
          this.variableToDeviceNo=newVariableToDeviceNo
        } else {
          //功率因素
          var keys=Object.keys(this.deviceNoToVariableTree)
          keys.forEach(item => {
            this.deviceNoToVariableTree[item].forEach(treeItem => {
              if(treeItem.no==this.nowApptypeGroup.no) {
                for(var i2=0,len2=treeItem.next.length;i2<len2;i2++) {
                  list.push(treeItem.next[i2])
                }
              }
            })
          })
        }
        return list
      },
      nowVariableNames () {
        if(isempty(this.nowVariableList)) {
          return []
        }
        var list=[]
        for(var i=0,len=this.nowVariableList.length;i<len;i++) {
          var item=this.nowVariableList[i]
          this.from2name[item.fromName]=item.name
          list.push(item.fromName) //name == fromName
        }
        return list
      },
      apptypeGroups () {
        return [{
          no: -2,
          name: '负荷率'
        },{
          no: -1,
          name: '用电日负荷'
        },{
          no: 13,
          name: '功率因素'
        }]
      },
      nowLoad () {
        //获取指定虚拟设备的额度负荷
        return deviceNo => {
          //当前虚拟变量关联的台账设备信息中的总功率配置
          if(deviceNo==undefined) {
            return undefined
          }
          var info=this.getArchivesByDeviceNos([deviceNo])[0]
          if(info==undefined) {
            return undefined
          }
          //查询类型typepropertycode为Power的配置
          var power=info.next.find((data) => {
            return data.propertyCode=="Power"
          })
          if(isempty(power)||isempty(power.value)) {
            return undefined
          }
          return parseInt(power.value)
        }
      },
      getLoadByVariable () {
        //获取指定变量对应设备的配置的额定负荷
        return key => {
          var deviceNo=this.variableToDeviceNo[key]
          if(deviceNo==undefined) {
            return undefined
          }
          return this.nowLoad(deviceNo)
        }
      },
      nowShowDataList () {
        //当前应该显示的数据列表，就是计算好的一天的每个整点值的数据
        if(this.nowApptypeGroup.no==-2) {
          if(isempty(this.nowVirtualDeviceList)) {
            return []
          }
        }
        if(isempty(this.dataObject)) {
          return []
        }
        var list=[]
        var keys=Object.keys(this.dataObject)

        for(var i=0,len=keys.length;i<len;i++) {
          var key=keys[i]
          var name=this.from2name[key]
          var nList=[name]
          //加入最大值最小值和平均值
          var data={};
          //var data = this.dataObject[key][0]
          //年度的data分开计算
          if(this.radioSelect=="year"||this.radioSelect=="quarter") {
            let monthData=this.dataObject[key];
            let dataArr=[];
            monthData.forEach(item => {
              if(!isempty(item.data)) {
                let itemData=Number(cutDigital(this.$historyTools.getAvg(item.data,item.avg)));
                dataArr.push(itemData);
              } else {
                dataArr.push(null);
              }

            })
            data.data=dataArr;
            data.avg=-1.11;
          } else {
            data=this.dataObject[key][0]
          }
          if(!isempty(data)&&!isempty(data.data)) {
            if(this.nowApptypeGroup.no==-2) {
              var load=100;
              var load=this.getLoadByVariable(key)
              if(load==undefined||load==0) {
                nList.push('- -')
                nList.push('- -')
                nList.push('- -')
              }
              nList.push(cutDigital(this.$historyTools.getMax(data.data,data.max)/load*100)+this.getMaxMinTime(data.maxtime))
              nList.push(cutDigital(this.$historyTools.getMin(data.data,data.min)/load*100)+this.getMaxMinTime(data.mintime))
              nList.push(cutDigital(this.$historyTools.getAvg(data.data,data.avg)/load*100))
            } else {
              nList.push(cutDigital(this.$historyTools.getMax(data.data,data.max))+this.getMaxMinTime(data.maxtime))
              nList.push(cutDigital(this.$historyTools.getMin(data.data,data.min))+this.getMaxMinTime(data.mintime))
              nList.push(cutDigital(this.$historyTools.getAvg(data.data,data.avg)))
            }
            data=data.data;
            if(this.radioSelect=="day") {
              //只要整点值
              data=data.filter((item,index) => {
                return index%12==0
              })
            }
            if(this.nowApptypeGroup.no==-2) {
              //计算负荷率
              nList.addAll(data.map(item => {
                if(isnull(item)) {
                  return []
                }
                return cutDigital(item/load*100)
              }))
            } else {
              //debugger
              nList.addAll(data.map(item => {
                if(isnull(item)) {
                  return []
                }
                return cutDigital(item)
              }))
            }
          }
          list.push(nList)
        }
        return list
      },
      columns () {
        //列表的项，每个整点值
        var list=[]
        list.push({
          name: "最大值",
          width: 180
        },{
          name: "最小值",
          width: 180
        },{
          name: "平均值"
        })
        //debugger
        switch(this.radioSelect) {
          case 'day':
            for(var i=0;i<24;i++) {
              list.push({
                name: (i<10? "0":'')+i+":00"
              })
            }
            break;
          case 'month':
            for(var i=0;i<=30;i++) {
              list.push({
                name: (i+1)+'日'
              });
            }
            break
          case 'quarter':
            var Month=[
              ["一月","二月","三月"],
              ["四月","五月","六月"],
              ["七月","八月","九月"],
              ["十月","十一月","十二月"]
            ]
            var quarter=parseInt((this.nowSelectDate.getMonth()+3)/3)
            var quarterList=Month[quarter-1]
            for(var i=0;i<12;i++) {
              list.push({
                name: quarterList[i]
              })
            }
            break
          case 'year':
            name=name.subByFirstChar(".")
            for(var i=0;i<12;i++) {
              list.push({
                name: (i+1)+'月'
              })
            }
            break
        }
        return list
      },
    },
    watch: {
      radioSelect (nv,ov) {
        this.search()
      },
      nowShowDataList (nv,ov) {
        //获取到新的数据了，重新渲染
        if(!isempty(nv)) {
          this.reloadChart(copy(nv))
        } else {
          this.options.series=[]
          this.options.legend.data=[]
          this.options.legend.selected={}
          this.options.title.text=this.nowDateText
          this.$refs.vchart.setData(this.options,true)
        }
        if(this.warnMessage!='') {
          this.$dialogMethod.showMessage(this.warnMessage)
          this.warnMessage=''
        }
      },
      nowVariableNames (nv,ov) {
        this.search()
      },
      nowSelectDate (nv,ov) {
        this.search()
      }
    },
    methods: {
      //树形结构选择
      checkFun (val) {
        this.nowVirtualDevice=val
        this.nowVirtualDeviceList=val
      },
      //获取最大值和最小值的时间
      getMaxMinTime (dateTime) {
        let a=dateTime
        let date=new Date(dateTime);
        let day=date.getDate();
        let month=date.getMonth();
        let hour=date.getHours();
        let minutes=date.getMinutes();
        let second=date.getSeconds();
        let returnStr='';
        switch(this.radioSelect) {
          case 'day':
            returnStr='('+(hour<10? "0":'')+hour+":"+(minutes<10? "0":'')+minutes+':'+(second<10? "0":'')+second+')'
            break;
          case 'month':
            returnStr='('+(day+1)+'日'+')'
            break;
          default:
            returnStr='('+(month+1)+'月'+')'
        }
        return returnStr;
      },
      downloadExcel () {
        let title='<thead><tr>'
        title+='<th colspan=6>'+new Date().formatByTime('-')+' 节能评估'+'</th>'
        title+='</tr></thead>'
        let aa=document.getElementsByTagName('thead')[0];//头部表达
        let bb=document.getElementsByTagName('tbody')[0];//列表内容
        let table=title+aa.innerHTML+bb.innerHTML
        exportToExcel(table,"节能评估报告")
      },
      checkGroups (item) {
        this.nowApptypeGroup=item
        //this.$store.deviceStore.commit('setSaveEnergyDeviceList', item)
      },
      checkItem (item) {
        this.$store.deviceStore.commit('setSaveEnergyDeviceList',item)
        this.search()
      },
      selectDate (date) {
        this.$store.cacheStore.commit("setNowSelectDate",date)
        this.$refs.datePicker.hide()
      },
      //下拉框选择
      select_fn () {
        var obj=[]
        obj=this.apptypeGroups.filter(item => item.no==this.apptype)
        this.nowApptypeGroup=obj[0]
        // this.$store.deviceStore.commit('setSaveEnergyDeviceList', obj)
        this.search()
      },
      search () {

        // if(!this.dataSelectCheck()) {
        //   return;
        // }


        // if(isempty(this.nowVirtualDeviceList)) {
        //   return
        // }
        if(isempty(this.nowVariableNames)) {
          this.$message({message: '请选择设备',type: 'warning'});
          return
        }
        this.loading=true
        // this.$dialogMethod.showLoading('数据正在加载...')

        //查询数据
        this.$api.historyApi.searchVariableHistoryWithDateType(this.nowVariableNames.join(','),this.radioSelect,this.serchTime.getTime(),
          respon => {
            this.$set(this,'dataObject',respon) // dataObject = respon
            this.loading=false
            // this.$dialogMethod.closeLoading()
          })
      },

      dataSelectCheck () {
        //debugger
        if(this.radioSelect=="") {
          this.$dialogMethod.showMessage('请选择查询周期！')
          return false;
        }

        if(this.radioSelect=='day'&&this.serchTime=="") {
          this.$dialogMethod.showMessage('日周期未选择时间！')
          return false;
        }

        if((this.radioSelect=='month'&&this.serchTime=="")||(this.radioSelect=='quarter'&&this.serchTime=="")) {
          this.$dialogMethod.showMessage('月、季周期未选择时间！')
          return false;
        }

        if(this.radioSelect=='year'&&this.serchTime=="") {
          this.$dialogMethod.showMessage('年周期未选择时间！')
          return false;
        }
        return true;

      },

      exportExcel () {},
      reloadChart (list) {
        var selected={}
        var legend=[]
        var seriesList=[]
        var baseTime=new Date(this.serchTime).getTime()
        var temp=[]
        //debugger;
        switch(this.radioSelect) {
          case 'day':
            var keys=Object.keys(list)
            var dataList=list[keys[0]]
            var seriesList=[]
            var name=this.fromName[keys[0]]? this.fromName[keys[0]]:keys[0]
            name=name.subByFirstChar(".")
            var vlist=[]
            //取整点值
            for(var i=0,len=dataList.length;i<len;i++) {
              if(i>3) {
                temp.push(dataList[i]);
              }
            }

            for(var i=0;i<temp.length;i++) {
              var item=temp[i]
              if(isNaN(parseFloat((item)))||isnull(parseFloat((item)))) {
                item=undefined
              }
              var label=(i<10? "0":'')+i+":00"
              vlist.push([label,item])
            }

            seriesList.push({
              name: name,
              type: 'bar',
              data: vlist
            })
            break;
          case 'month':
            var keys=Object.keys(list)
            var dataList=list[keys[0]]
            var name=this.fromName[keys[0]]? this.fromName[keys[0]]:keys[0]
            name=name.subByFirstChar(".")
            var vlist=[]
            for(var i=0,len=dataList.length;i<len;i++) {
              if(i>3) {
                temp.push(dataList[i]);
              }
            }
            for(var i=0;i<temp.length;i++) {
              //var item = dataList[i]
              var item=temp[i]
              if(isNaN(parseFloat((item)))||isnull(parseFloat((item)))) {
                item=undefined
              }
              vlist.push([(i+1)+'日',item])

            }
            seriesList.push({
              name: name,
              type: 'bar',
              data: vlist,
            })
            break
          case 'quarter':
            var keys=Object.keys(list)
            var dataList=list[keys[0]]
            var seriesList=[]
            var quarter=parseInt((this.nowSelectDate.getMonth()+3)/3)
            var Month=[
              ["一月","二月","三月"],
              ["四月","五月","六月"],
              ["七月","八月","九月"],
              ["十月","十一月","十二月"]
            ]
            var quarterList=Month[quarter-1]
            var name=this.fromName[keys[0]]? this.fromName[keys[0]]:keys[0]
            name=name.subByFirstChar(".")
            var vList=[]
            for(var i=0,len=dataList.length;i<len;i++) {
              if(i>3) {
                temp.push(dataList[i]);
              }

            }

            for(var i=0;i<temp.length;i++) {
              var item=temp[i]
              if(isNaN(parseFloat((item)))||isnull(parseFloat((item)))) {
                item=undefined
              }
              vList.push([quarterList[i],item])

            }

            seriesList.push({
              name: name,
              type: 'bar',
              data: vList
            })
            break
          case 'year':
            var keys=Object.keys(list)
            var dataList=list[keys[0]]
            var seriesList=[]
            var name=this.fromName[keys[0]]? this.fromName[keys[0]]:keys[0]
            name=name.subByFirstChar(".")
            var vList=[]
            for(var i=0,len=dataList.length;i<len;i++) {
              var item=dataList[i]
              if(i>3) {
                if(isNaN(parseFloat((item)))||isnull(parseFloat((item)))) {
                  item=undefined
                }
                vList.push([(i-3)+'月',item])
              }
            }

            seriesList.push({
              name: name,
              type: 'bar',
              data: vList
            })
            break
        }
        this.options.series=seriesList
        this.options.legend.data=legend
        this.options.legend.selected=selected
        //this.options.title.text = this.nowDateText
        this.options.title.text=this.serchTime.formatByDate('-')
        this.$refs.vchart.setData(this.options,true)
      }
    }
  }
</script>

<style scoped lang="scss">
  .energySaving {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>